import {ApiRequest} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {IUserProfileBase} from "../define";
import {UserLoginResponse, WELL_KNOWN_PLATFORM} from "./user-login.protocol";

export const UserRegisterUrl = `/do_register`;
export const UserRegisterMethod = ERequestType.TYPE_POST;

export interface UserRegisterBody extends ApiRequest {
	login: string;
	password: string;
	platform?: WELL_KNOWN_PLATFORM;
	nickname: string;
}

export interface UserRegisterResponse<IProfile extends IUserProfileBase> extends UserLoginResponse<IProfile> {
}
